<template>
	<div id="#app">
		<MaintenanceMode v-if="maintenanceMode" />
		<router-view v-else />
	</div>
</template>


<script>

import MaintenanceMode from './components/MaintenanceMode.vue'
import configs from './middleware/configs';

export default {
	name: 'App',
	components: {
		MaintenanceMode
	},
	data() {
		return {
			maintenanceMode: false
		}
	},
	async created() {
		fetch(`${ configs.firebaseFunctions }/getStatusConfig?nm_so=site`)
			.then((response) => response.json())
			.then((data) => {
				this.maintenanceMode = data.in_maintenance
			});
	},
}

</script>


<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

@media (min-width: 1024px) {
  #adopt-controller-button {
    position: fixed !important;
    bottom: 2rem !important;
    left: 1.875rem !important;
    transform: none !important;
  }

  #adopt-controller-button svg {
    width: 100% !important;
    height: 100% !important;
  }

  .adopt-c-blcsFr {
    bottom: 5.625rem !important;
    left: 5.625rem !important;
  }
}

</style>